import React from "react";

import "./Preloader.css";

const Preloader = props => {
  return (
    <div
      className={
        !props.preloader
          ? `preloader ${props.type} preloader-disabled`
          : `preloader ${props.type} preloader-active`
      }
    >
      <div className="showbox">
        <div className="loader">
          <svg className="circular" viewBox="25 25 50 50">
            <circle
              className="path"
              cx="50"
              cy="50"
              r="20"
              fill="none"
              strokeWidth="2"
              strokeMiterlimit="10"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

Preloader.propTypes = {};

export default Preloader;



// WEBPACK FOOTER //
// ./src/components/Preloader.js